import { SvgIconProps } from '@c/icons/types';
import { Facebook, Instagram, Pinterest, Youtube } from '@c/icons/socials';
import Link from 'next/link';

type SocialVariant = 'facebook' | 'instagram' | 'youtube' | 'pinterest';
interface SocialLinkProps {
  variant: SocialVariant;
  color?: string;
}

const getAssets = (
  v: SocialVariant
): {
  href: string;
  Icon: ({ svgProps, pathProps }: SvgIconProps) => JSX.Element;
} => {
  if (v === 'facebook')
    return {
      href: 'https://www.facebook.com/gearfocusmarketplace',
      Icon: Facebook,
    };
  if (v === 'instagram')
    return {
      href: 'https://www.instagram.com/gearfocusmarketplace/',
      Icon: Instagram,
    };
  if (v === 'pinterest')
    return {
      href: 'https://www.pinterest.com/gearfocusmarketplace/_created/',
      Icon: Pinterest,
    };
  if (v === 'youtube')
    return {
      href: 'https://www.youtube.com/gearfocus',
      Icon: Youtube,
    };
  return { href: '/', Icon: Facebook };
};

const SocialLink = ({ variant, color = 'fill-brand-black' }: SocialLinkProps) => {
  const { href, Icon } = getAssets(variant);
  return (
    <Link
      className="flex h-[2.4rem] w-[2.4rem] items-center justify-center"
      href={href}
      aria-label={variant}
    >
      <Icon
        svgProps={{
          className:
            `${color} hover:fill-brand-secondary transition-colors flex items-center justify-center`,
        }}
      />
    </Link>
  );
};

export default SocialLink;
